import { useEffect } from "react";
import { isWeb } from "tamagui";

export function useKeyTrigger(
  keyMap: Record<string, string> | null | undefined,
  cb: (value: string) => void,
  disabled?: boolean,
) {
  useEffect(() => {
    if (!keyMap) return;
    if (!isWeb) return;
    if (disabled) return;

    const handleKey = (e: KeyboardEvent) => {
      const val = keyMap[e.key];

      if (val !== undefined) {
        e.preventDefault();
        e.stopPropagation();
        cb(val);
      }
    };

    document.body.addEventListener("keydown", handleKey);
    return () => document.body.removeEventListener("keydown", handleKey);
  }, [keyMap, cb, disabled]);
}
